const storyMap = {
  selectProject: "בחר פרויקט",
  noProjects: "אין פרויקטים",
  addEpic: "הוסף אפיק",
  addStory: "הוסף סיפור",
  editCard: "ערוך כרטיס",
  deleteCard: "מחק כרטיס",
  deleteColumn: "מחק עמודה",
  deleteColumnConfirm: "למחוק את העמודה וכל הכרטיסים בה?",
  epicPlaceholder: "שם האפיק...",
  storyPlaceholder: "שם הסיפור...",
  subStories: "תתי-סיפורים",
  addSub: "הוסף תת-סיפור",
  subPlaceholder: "תת-סיפור...",
  emptyBoard: "הלוח ריק — הוסף אפיק ראשון",
  demoMode: "מצב הדגמה",
  demoModeHint: "נתוני הדגמה — אין חיבור ל-Supabase. הנתונים אינם אמיתיים.",
  colorPicker: "צבע",
  noColor: "ללא צבע",
  cardCount: "כרטיסים",
  addFeature: "הוסף פיצ׳ר",
  featurePlaceholder: "שם הפיצ׳ר...",
  realtimeConnected: "מחובר",
  realtimeConnecting: "מתחבר...",
  realtimeDisconnected: "מנותק",
  notes: "הערות",
  addNote: "הוסף הערה",
  notePlaceholder: "הערות, קריטריונים, קישורים...",
  diagram: "דיאגרמה",
  editDiagram: "עריכת דיאגרמה",
  diagramPlaceholder: "graph TD\n  A-->B",
  preview: "תצוגה מקדימה",
  save: "שמור",
  filterSearch: "חיפוש כרטיסים...",
  clearFilters: "נקה סינון",
  epic: "אפיק",
  feature: "פיצ׳ר",
  story: "סיפור",
  statsEpics: "אפיקים",
  statsFeatures: "פיצ׳רים",
  statsStories: "סיפורים",
  statsCompletion: "השלמת תתי-סיפורים",
  statsTotal: "סה״כ כרטיסים",
  estimation: "הערכת מאמץ",
  noEstimation: "ללא הערכה",
  totalPoints: "סה״כ נקודות",
  export: "ייצוא",
  exportJSON: "ייצוא JSON",
  exportMarkdown: "ייצוא Markdown",
  exportPNG: "ייצוא PNG",
  exporting: "מייצא...",
  openInEditor: "פתח בעורך",
  createNote: "יצירת פתק...",
  hasNote: "יש פתק מקושר",
  linkEntity: "קשר ישות",
  linkedEntities: "ישויות מקושרות",
  searchEntity: "חפש ישות לקישור...",
  unlinkEntity: "הסר קישור",
  noLinkedEntities: "אין ישויות מקושרות",
  defaultEpic: "אפיק",
  defaultFeature: "פיצ׳ר חדש",
  defaultStory: "סיפור חדש",
} as const;
export default storyMap;
